export default __webpack_public_path__ + "static/media/Warlord's War Hammer.57b7f454.jpg";